import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface SolutionCardProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  description?: string;
  children?: React.ReactNode;
}

const SolutionCard = ({
  icon: Icon,
  title,
  subtitle,
  description,
  children,
}: SolutionCardProps) => {
  return (
    <div className="animate-fade-in">
      <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
        <Icon className="h-7 w-7 text-primary" />
        {title}
      </h2>
      <Card className="border-primary/20 hover:border-primary/40 transition-colors">
        <CardHeader>
          <CardTitle className="text-lg">{subtitle}</CardTitle>
          {description && (
            <CardDescription className="text-base mt-1">
              {description}
            </CardDescription>
          )}
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </div>
  );
};

export default SolutionCard;
